import DatePicker, { CalendarContainer } from "react-datepicker";
import { chakra } from "@chakra-ui/react";
import { CalendarHeader } from "../calendar-header";

import "react-datepicker/dist/react-datepicker.css";
import "../calendarInput/calendarInput.css";

const CkCalendarContainer = chakra(CalendarContainer);

type InlineCalendarProps = {
  selected: Date | null;
  onChange: (date: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
};

function InlineCalendar({
  selected,
  onChange,
  minDate,
  maxDate,
}: InlineCalendarProps) {
  return (
    <DatePicker
      inline
      selected={selected}
      onChange={onChange}
      minDate={minDate}
      maxDate={maxDate}
      formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 3).toUpperCase()}
      renderCustomHeader={CalendarHeader}
      calendarContainer={({ children, ...calendarProps }) => (
        <CkCalendarContainer
          {...calendarProps}
          fontFamily="body"
          border="1px solid #D1D1D6"
          boxShadow="0px 4px 4px rgba(50, 50, 71, 0.08), 0px 4px 8px rgba(50, 50, 71, 0.06)"
          borderRadius="13px"
          fontSize="unset"
          padding="1"
        >
          {children}
        </CkCalendarContainer>
      )}
    />
  );
}

InlineCalendar.displayName = "InlineCalendar";

export { InlineCalendar };
export type { InlineCalendarProps };
